import cx from 'classnames'

import { logEvent } from 'lib/analytics'
import { Link } from 'features/i18n/router'
import { ROUTE_PATH } from 'lib/paths'
import { User } from 'lib/_types'

import Avatar from 'components/Avatar'

import './style.scss'

type UserListVerticalProps = {
  users?: User[]
  mode?: 'grid' | 'list'
  className?: string
}

const UserListVertical = ({
  className,
  users = [],
  mode = 'grid',
}: UserListVerticalProps) => {
  return (
    <div
      className={cx('UserListVertical', `UserListVertical--${mode}`, className)}
      style={
        mode === 'list'
          ? { gridTemplateColumns: `repeat(${users.length}, 20%)` }
          : {}
      }
    >
      {users.map((user) => (
        <Link
          key={user.id}
          onClick={() => {
            logEvent.user_profile_open({
              target_user_id: user.id?.toString(),
              from: 'undefined',
            })
          }}
          to={ROUTE_PATH.USER(user.id)}
          className="UserListVertical__item"
        >
          <Avatar
            wrapperClassName="UserListVertical__item__avatar"
            user={user}
          />

          <div className="UserListVertical__item__nickname">
            {user.nickname}
          </div>

          <div className="UserListVertical__item__bio">{user.biography}</div>
        </Link>
      ))}
    </div>
  )
}

export default UserListVertical
